import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { breakpoints, mixins, colors } from '../css-variables'
import GravityFormForm from 'gatsby-gravityforms-component'
import { useStaticQuery, graphql } from 'gatsby'
import formErrorIcon from "./../../svg/form-error-icon-red.svg"
import { getCountryList } from '../../components/update-info-form/form-helpers'

const AllGravityData = () => {
    const { allWpGfForm } = useStaticQuery(
        graphql`
            query {
              allWpGfForm {
                    edges {
                      node {
                        databaseId
                        title
                        description
                        descriptionPlacement
                        formFields {
                          nodes {
                            id: databaseId
                            type
                            ... on WpEmailField {
                              id: databaseId
                              label
                              isRequired
                              inputs {
                                ... on WpEmailInputProperty {
                                  id
                                  name
                                  autocompleteAttribute
                                  customLabel
                                  defaultValue
                                  label
                                  placeholder
                                }
                              }
                              placeholder
                              type
                              visibility
                              errorMessage
                              descriptionPlacement
                              description
                              cssClass
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                            }
                            ... on WpTextField {
                              id: databaseId
                              label
                              isRequired
                              placeholder
                              type
                              value
                              visibility
                              inputName
                              maxLength
                              errorMessage
                              description
                              descriptionPlacement
                              defaultValue
                              cssClass
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                            }
                            ... on WpTextAreaField {
                                id: databaseId
                                label
                                isRequired
                                placeholder
                                value
                                visibility
                                inputName
                                maxLength
                                errorMessage
                                description
                                descriptionPlacement
                                defaultValue
                                cssClass
                                conditionalLogic {
                                  actionType
                                  logicType
                                  rules {
                                    fieldId
                                    operator
                                    value
                                  }
                                }
                            }
                            ... on WpPhoneField {
                              id: databaseId
                              label
                              isRequired
                              value
                              visibility
                              type
                              placeholder
                              phoneFormat
                              errorMessage
                              defaultValue
                              cssClass
                              description
                              descriptionPlacement
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                            }
                            ... on WpNameField {
                              id: databaseId
                              label
                              isRequired
                              errorMessage
                              descriptionPlacement
                              description
                              cssClass
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              inputs {
                                id
                                label
                                ... on WpNameInputProperty {
                                  id
                                  name
                                  autocompleteAttribute
                                  choices {
                                    isSelected
                                    text
                                    value
                                  }
                                  customLabel
                                  defaultValue
                                  hasChoiceValue
                                  isHidden
                                  key
                                  label
                                  placeholder
                                }
                              }
                              type
                              visibility
                            }
                            ... on WpAddressField {
                              id: databaseId
                              inputs {
                                  id
                                  label
                                  ... on WpAddressInputProperty {
                                    id
                                    name
                                    label
                                    isHidden
                                    key
                                    defaultValue
                                    customLabel
                                    autocompleteAttribute
                                  }
                              }
                              isRequired
                              label
                              labelPlacement
                              type
                              visibility
                              errorMessage
                              descriptionPlacement
                              description
                              defaultState
                              defaultProvince
                              defaultCountry
                              cssClass
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  value
                                  operator
                                }
                              }
                              addressValues {
                                city
                                country
                                lineTwo
                                state
                                street
                                zip
                              }
                              addressType
                            }
                            ... on WpRadioField {
                              id: databaseId
                              choices {
                                ... on WpRadioFieldChoice {
                                  isOtherChoice
                                  isSelected
                                  text
                                  value
                                }
                                text
                                value
                              }
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              description
                              descriptionPlacement
                              errorMessage
                              hasChoiceValue
                              hasOtherChoice
                              inputName
                              isRequired
                              label
                              type
                              value
                              visibility
                            }
                            ... on WpSelectField {
                              id: databaseId
                              choices {
                                text
                                value
                                ... on WpSelectFieldChoice {
                                  isSelected
                                  text
                                  value
                                }
                              }
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              defaultValue
                              description
                              descriptionPlacement
                              errorMessage
                              isRequired
                              placeholder
                              label
                              type
                              value
                              visibility
                            }
                            ... on WpCheckboxField {
                              id: databaseId
                              checkboxValues {
                                inputId
                                text
                                connectedChoice {
                                  text
                                  value
                                  ... on WpCheckboxFieldChoice {
                                    isSelected
                                    text
                                    value
                                  }
                                }
                                connectedInput {
                                  id
                                  label
                                  ... on WpCheckboxInputProperty {
                                    id
                                    name
                                    label
                                  }
                                }
                                value
                              }
                              choices {
                                text
                                value
                                ... on WpCheckboxFieldChoice {
                                  isSelected
                                  text
                                  value
                                }
                              }
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              description
                              descriptionPlacement
                              hasChoiceValue
                              errorMessage
                              inputs {
                                id
                                label
                                ... on WpCheckboxInputProperty {
                                  id
                                  name
                                  label
                                }
                              }
                              isRequired
                              label
                              type
                              visibility
                            }
                            ... on WpCaptchaField {
                              id: databaseId
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              description
                              descriptionPlacement
                              label
                            }
                            ... on WpSectionField {
                              id: databaseId
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              description
                              displayOnly
                              label
                              type
                              visibility
                            }
                            ... on WpHtmlField {
                              id: databaseId
                              content
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              displayOnly
                              label
                              type
                              visibility
                            }
                            ... on WpDateField {
                              id: databaseId
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              description
                              descriptionPlacement
                              displayOnly
                              isRequired
                              label
                              type
                              visibility
                            }
                            ... on WpNumberField {
                              id: databaseId
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              defaultValue
                              cssClass
                              description
                              descriptionPlacement
                              errorMessage
                              inputName
                              inputType
                              isRequired
                              label
                              labelPlacement
                              numberFormat
                              placeholder
                              rangeMax
                              rangeMin
                              size
                              type
                              value
                              visibility
                            }
                            ... on WpFileUploadField {
                              id: databaseId
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              description
                              descriptionPlacement
                              errorMessage
                              inputType
                              isRequired
                              label
                              labelPlacement
                              maxFileSize
                              type
                              value
                              fileUploadValues {
                                basePath
                                baseUrl
                                filename
                                url
                              }
                              visibility
                            }
                            ... on WpWebsiteField {
                              id: databaseId
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              defaultValue
                              description
                              descriptionPlacement
                              errorMessage
                              inputName
                              inputType
                              isRequired
                              label
                              labelPlacement
                              placeholder
                              size
                              type
                              value
                              visibility
                            }
                            ... on WpPostTitleField {
                              id: databaseId
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              defaultValue
                              description
                              descriptionPlacement
                              errorMessage
                              inputName
                              inputType
                              isRequired
                              label
                              labelPlacement
                              placeholder
                              type
                              value
                              visibility
                            }
                            ... on WpPostImageField {
                              id: databaseId
                              adminLabel
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              description
                              descriptionPlacement
                              errorMessage
                              hasAlt
                              hasCaption
                              hasDescription
                              hasTitle
                              inputType
                              isFeaturedImage
                              isRequired
                              label
                              labelPlacement
                              type
                              value
                              visibility
                              subLabelPlacement
                              imageValues {
                                altText
                                basePath
                                baseUrl
                                caption
                                description
                                filename
                                title
                                url
                              }
                            }
                            ... on WpPostContentField {
                              id: databaseId
                              adminLabel
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              defaultValue
                              description
                              descriptionPlacement
                              errorMessage
                              inputName
                              inputType
                              isRequired
                              label
                              labelPlacement
                              type
                              value
                              visibility
                              placeholder
                            }
                            ... on WpPostCustomWebsiteField {
                              id: databaseId
                              adminLabel
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              defaultValue
                              description
                              descriptionPlacement
                              errorMessage
                              inputName
                              inputType
                              isRequired
                              label
                              labelPlacement
                              placeholder
                              type
                              value
                              visibility
                            }
                            ... on WpPostCustomTextField {
                              id: databaseId
                              adminLabel
                              conditionalLogic {
                                actionType
                                logicType
                                rules {
                                  fieldId
                                  operator
                                  value
                                }
                              }
                              cssClass
                              defaultValue
                              description
                              descriptionPlacement
                              errorMessage
                              inputName
                              inputMaskValue
                              inputType
                              isRequired
                              label
                              labelPlacement
                              maxLength
                              placeholder
                              type
                              value
                              visibility
                            }
                          }
                        }
                        submitButton {
                          text
                          conditionalLogic {
                            actionType
                            logicType
                            rules {
                              fieldId
                              operator
                              value
                            }
                          }
                          imageUrl
                          layoutGridColumnSpan
                          location
                          type
                          width
                        }
                        confirmations {
                          conditionalLogic {
                            actionType
                            logicType
                            rules {
                              fieldId
                              operator
                              value
                            }
                          }
                          id
                          isActive
                          isAutoformatted
                          isDefault
                          message
                          name
                          type
                          url
                          queryString
                          pageId
                        }
                      }
                    }
                  }
            }
        `
    )
    return allWpGfForm
  }

  function handleError({id, values, error, reset}) {
    //handle error
    //console.log('values', values, 'error', error)
    let message = ''
    if(error && error?.data?.message){
      message = error.data.message
    } else if(error && error?.data?.validation_messages){
      let messages = error.data.validation_messages
      if(typeof messages === 'object'){
        Object.keys(messages).forEach(msg => message += `field ${msg}: ${messages[msg]} `)
      }
    }
    sendErrorToLog(id, error, message, values)
}

function handleSuccess({values, reset, confirmations, formData}) {
    
    //handle success
    //console.log('success', values, confirmations, formData)
    if(formData?.title && typeof gtag === 'function' ) {
      gtag('event', 'formSubmission', {
        'formTitle': formData.title
      })
    }

}

const sendErrorToLog = ( id, error, message, values ) => {
  let errorData = {
    formId: id,
    message: message,
    requestUrl: error?.config?.url,
    currentPage: window.location.href,
  }
  
  return fetch(`${process.env.GATSBY_GRAVITYFORMS_SOURCE}/wp-json/wfaa-gravity-forms-addon/v1/log`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'Authorization': `Bearer ${process.env.GATSBY_GFORM_LOGGING_CLIENT_ID}`,
    },
    body: JSON.stringify(errorData),
    redirect: 'follow'
  })
  .then(res =>
    (!res.ok)
      ? res.json().then(() => {throw new Error('an error occurred')})
      : res.json()
  )
}

const GravityForm = ({className, id}) => {
    const [formData, setFormData] = useState([]);
    const [checkboxFieldData, setCheckboxFieldData] = useState({});
    const [keepTrackOfCheckboxes, setkeepTrackOfCheckboxes] = useState([]);
    const [countryList] = useState(getCountryList())
    //const [choices, setChoices] = useState({});
    //console.log(id)
    const gfData = AllGravityData()
    useEffect(() => {
        let selectCurrentForm = gfData.edges.filter(function (e) {
          return parseInt(e.node.formId || e.node.databaseId) === parseInt(id)
        })
        setFormData(selectCurrentForm[0].node)
      }, []);
    
    //console.log(gfData)

    const handleFieldChange = (fieldId, value, inputId) => {
        let input = `input_${fieldId}_${inputId}`;
        let checkForInput = keepTrackOfCheckboxes.includes(input)
        if (checkForInput){
            const updateCheckboxData = {
                ...checkboxFieldData
            }
            delete updateCheckboxData[input]

            setCheckboxFieldData(updateCheckboxData)

            let updateChecks = keepTrackOfCheckboxes
            setkeepTrackOfCheckboxes(updateChecks.filter(i => i !== input))
        } else{
            setCheckboxFieldData(checkboxFieldData => ({
                ...checkboxFieldData,
                [input]:value
            }))

            let updateChecks = keepTrackOfCheckboxes
            setkeepTrackOfCheckboxes(updateChecks.concat(input))
        }
        
    }

    
    let fullhostname = process.env.GATSBY_GRAVITYFORMS_SOURCE || "https://uwalumni.wpengine.com";
    /*if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    fullhostname = protocol.concat("//").concat(hostname);
    }*/
    
    return (
        <div className={className} id="gravity-form-wrap">
            <GravityFormForm
                        id={id}
                        formData={gfData}
                        lambda={`${fullhostname}/wp-json/formsubmit/v1/submit/${id}`}
                        successCallback={handleSuccess}
                        errorCallback={handleError}
                        onChange={handleFieldChange}
                        checkboxes={checkboxFieldData}
                        countryList={countryList}
                        captchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
                    />
        </div>
    )
}
    
const StyledGravityForm = styled(GravityForm)`
${mixins.formStyles}
max-width: 100%;
margin: 0 auto 24px auto;
ul {
    text-align: left;
    margin-bottom: 24px;
}
li{
    margin-bottom: 24px;
}

ul.gform_fields {
    list-style-type: none;
    margin: 0;
}
p {
    text-align: left;
}
button.gravityform__button {
    ${mixins.buttons}
    border:none;
    cursor:pointer;
    :disabled{
        background-color: #CCCCCC;
        cursor: auto;
        :hover{
            box-shadow:none;
        }
    }
}
a {
    ${mixins.a}
}
label.gfield_label {
    font-weight: 500;
    margin-bottom:12px;
    &--subfield {
        font-weight: normal;
    }
    .gfield_required{
        color: ${colors.badgerRed};
        margin-left: 5px;
    }
}
input {
    width: 100%;  
}
input[type='date']{
    max-width: 250px;
}
.gfield_radio, .gfield_checkbox {
    margin-left: 0;
    li {
        list-style:none;
        margin-top:-26px;
        label{
            padding-left:0;
            
        }
        input[type="radio"]:checked + label::after, input[type="checkbox"]:checked + label::after{
            left: 3px;
        }
    }
}
.ginput_container {
    &_address,
    &_name {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;
        flex-flow: row-wrap;
    }
}
.subfield__wrapper {
    width: 100%;
    margin: 0 0 10px 0;
    @media screen and ${breakpoints.tabletS} {
        &.half-width {
            width: calc( 50% - 5px );
            margin: 0 5px 10px 0;
            &:nth-child(2n) {
                margin: 0 0 10px 5px;
              }
        }
      }
}
.validation_message, .validation_error, .gravityform_error_info{
    color:${colors.badgerRed};
    font-size: 16px;
    p{
        margin-bottom:12px;
        position:relative;
        :first-of-type{
            margin-left: 24px;
            :before{
                content: '';
                height:24px;
                width:24px;
                margin: 0 auto;
                padding: 0 0 0 24px;
                position: absolute;
                color: ${colors.buttonRed};
                top: 4px;
                left: -24px;
                background-image: url(${formErrorIcon});
                background-repeat: no-repeat;
              }
        }
    }
    ul{
        margin-left:48px;
        li{
            margin-bottom: 6px;
        }
    }
    .unknownError{
        color:black;
        background-color: ${colors.errorBGYellow};
        :first-of-type{
            padding: 12px 12px 12px 36px;
            margin: 0;
            :before{
                padding: 0 0 0 24px;
                top: 16px;
                left: 12px;
              }
        }
        
    }
}
.gravityform__error_message{
    margin-left: 24px;
    position: relative;
            :before{
                content: '';
                height:24px;
                width:24px;
                margin: 0 auto;
                padding: 0 0 0 24px;
                position: absolute;
                color: ${colors.buttonRed};
                top: 4px;
                left: -24px;
                background-image: url(${formErrorIcon});
                background-repeat: no-repeat;
              }
        }
}
.gform_confirmation_message{
}
.gfield_description{
    font-size:16px;
}
.gravityform__field__section{
    label{
        padding-bottom: 5px;
        border-bottom: 2px solid ${colors.borderGrey};
        text-transform: uppercase;
        font-weight:900;
    }
}
.gform_hidden, .gfield_visibility_administrative{
    display: none !important;
}
.half-width{
    select{
        margin-top: 0;
    }
}
input[type=file]::-webkit-file-upload-button { /* chromes and blink button */
    cursor: pointer; 
}
.grecaptcha-badge{
    visibility:hidden;
}
.gravityform__field__captcha {
    label{
        display:none;
    }
    .recaptchaBranding{
        font-size: 14px;
    }
}
.PhoneInput{
    .PhoneInputCountry{
      border: 2px solid #E0E0E0;
      padding: 0 10px;
      margin: 0 -2px 0 0;
    }
    .PhoneInputCountrySelect{
      margin-top: 10px;
    }
    .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow{
      color:${colors.buttonRed};
    }
    .PhoneInputCountrySelectArrow{
      color:${colors.buttonRed};
      width: 8px;
      height: 8px;
      border-bottom-width: 2px;
      border-right-width: 2px;
      opacity: 1;
      margin-left: 12px;
    }
    .PhoneInputCountryIcon{
      box-shadow:none;
    }
    .PhoneInputCountryIconImg{
      width: 30px;
      height: 20px;
      max-width: 30px;
    }
  }
  .inactive-btn-msg{
      font-weight: 500;
      span{
          color:${colors.badgerRed};
      }
  }
  #form-confirmation{
    padding-top: 48px;
    margin-top: 48px;
    border-top: 2px solid ${colors.borderGrey};
    }
`

export default StyledGravityForm